import { useCurrentUser } from 'javascripts/hooks';
import { useMutation } from '@apollo/client';

import { ADMIN, MANAGER, hasRoleAccess } from 'helpers/roles';
import eventEmitter from 'helpers/event-emitter';
import { ASSETS_DELETED } from 'constants/graphqlEvents';
import MUTATION_DELETE_ASSETS from './gql/mutateDeleteAssets.graphql';

import { useModal } from 'components/shared/hooks';
import { Modal } from 'components/core/modal/constants';

const NO_ACTION = null;
const EMPTY_RESULT = [NO_ACTION];

export default function useMenuActionDelete({ assets, onSuccess, onCalled }) {
  const { showModal, hideModal } = useModal();
  const user = useCurrentUser();

  const [deleteAssets] = useMutation(MUTATION_DELETE_ASSETS, {
    onCompleted: (data) => {
      hideModal(Modal.DELETE_PHOTOS);

      const { deletedIds } = data.assetsDelete;
      eventEmitter.trigger(ASSETS_DELETED, { deletedIds });

      onSuccess && onSuccess();
    },
  });

  const hasPermission =
    hasRoleAccess(user, [ADMIN, MANAGER]) ||
    assets.every((el) => el?.contributor.id === user.node_id);
  const validSelection = assets.length > 0;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = () => {
    const assetIds = assets.map((asset) => asset.id);

    const onCancel = () => {
      hideModal(Modal.DELETE_PHOTOS);
    };

    const onDelete = async (e) => {
      e.stopPropagation();
      onCalled && onCalled();
      deleteAssets({
        variables: { assetIds },
      });
    };

    showModal(Modal.DELETE_PHOTOS, {
      photoCount: assetIds.length,
      onCancel,
      onRequestClose: onCancel,
      onDelete,
    });
  };

  return [action];
}
